import React from "react";
import { useAppContext } from "Context/AppContext";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { Box } from "@mui/material";

export default function OpentSideBar() {
  const { showNoteApp, showSideBar, toggleSideBar, toggleNoteApp } =
    useAppContext();
  return (
    <div>
      <Box
        onClick={toggleSideBar}
        sx={{
          position: "fixed",
          right: -30,
          bottom: 15,
          backgroundColor: "#eeeeee",
          width: "60px",
          height: "40px",
          borderRadius: "30px",
          display: "flex",
          alignItems: "center",
          transition: "right 0.1s ease-in-out",
          "&:hover": {
            right: -25,
            backgroundColor: "#cccccc",
          },
        }}
      >
        <ChevronLeftIcon
          sx={{
            color: "#888888",
            ml: 0.5,
          }}
        />
      </Box>
    </div>
  );
}
